<template>
  <div>
    <h6>شماره همراه کاربر:</h6>
    <div v-if="user" class="user-wrapper">
      <div>
        <span class="font-bold" v-if="user.phone">{{ user.phone }}</span>
        <span class="font-bold" v-if="user.name">{{ " | " + user.name }}</span>
      </div>
      <div @click="clear" class="icon">
        <feather-icon icon="XIcon" class="w-5 h-5" />
      </div>
    </div>
    <vs-input
      v-else
      v-model="phone"
      placeholder="شماره همراه کاربر را وارد کنید..."
      class="w-100 mt-2"
      maxlength="11"
    />
    <p class="user-name">
      نکته: در صورت عدم وارد کردن شماره همراه کاربر، به صورت پیش فرض شماره متصدی
      ثبت خواهد شد.
    </p>

    <vs-popup title="تکمیل پروفایل" :active.sync="showRegisterPopup">
      <vs-col vs-w="6" vs-xs="12" class="mb-5">
        شماره همراه کاربر:
        <vs-input
          v-model="phone"
          placeholder="شماره همراه کاربر"
          class="w-100 mt-1"
          maxlength="11"
          disabled
        />
      </vs-col>
      <vs-col vs-w="6" vs-xs="12" class="mb-5">
        نام و نام خانوادگی کاربر:
        <vs-input
          v-model="name"
          placeholder="نام و نام خانوادگی کاربر"
          class="w-100 mt-1"
        />
      </vs-col>

      <vs-col vs-w="12" class="mb-0 mt-5">
        <vs-button @click="registerUser" class="w-full" color="secondary">
          تکمیل پروفایل
        </vs-button>
      </vs-col>
    </vs-popup>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import providerApiService from "../../../services/api/ProviderApiService";

export default {
  name: "User",
  data() {
    return {
      phone: this.value?.phone,
      name: "",
      user: null,
      showRegisterPopup: false,
    };
  },
  computed: {
    ...mapGetters({
      currentProvider: "profile/currentProvider",
    }),
  },
  methods: {
    searchUser() {
      this.$vs.loading();
      providerApiService
        .searchUser(this.currentProvider.id, this.phone)
        .then((result) => {
          if (result.data?.id) {
            this.user = result.data;

            if (!this.user.name) {
              this.showRegisterPopup = true;
            } else {
              this.$emit("input", result.data);
            }
          } else {
            this.showRegisterPopup = true;
          }
        })
        .catch((err) => {
          this.$vs.notify({
            text: err.message?.message,
            color: "danger",
            position: "bottom-center",
          });
        })
        .finally(() => this.$vs.loading.close());
    },
    registerUser() {
      if (!this.name) {
        this.$vs.notify({
          text: "نام و نام خانوادگی کاربر را وارد کنید.",
          color: "warning",
          position: "bottom-center",
        });
        return;
      }

      this.$vs.loading();
      providerApiService
        .registerUser(this.currentProvider.id, {
          ...this.user,
          phone: this.phone,
          name: this.name,
        })
        .then((result) => {
          this.user = result.data;
          this.name = result.data?.name;
          this.showRegisterPopup = false;
          this.$emit("input", result.data);
        })
        .finally(() => this.$vs.loading.close());
    },
    clear() {
      this.phone = "";
      this.name = "";
      this.user = null;
      this.$emit("input", null);
    },
  },
  props: {
    value: {
      type: Object,
    },
  },
  watch: {
    phone(newValue) {
      if (this.showRegisterPopup) {
        return;
      }

      if (newValue.length === 11) {
        setTimeout(this.searchUser, 100);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.user-name {
  flex: 1;
  font-weight: 700;
  color: #000000;
  font-size: 0.85rem;
  margin: 5px 5px;
}

.user-wrapper {
  display: flex;
  align-items: center;
  background-color: #e0e0e0;
  border-radius: 10px;
  padding: 5px 10px;
  margin-top: 10px;
  width: fit-content;
  gap: 5px;

  .icon {
    display: flex;
    align-items: center;
    padding: 5px;
    cursor: pointer;
  }
}
</style>
